export default "__VITE_ASSET__BpoT$qnz__"